import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Select from "../../components/form/Select";
import SelectAjax from "../../components/form/SelectAjax";
import BtBloco from '../../components/buttons/BtBloco';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Component from "../blocos-planilha/Component";
import Ws from '../../config/Ws';
import TipoPlanilha from "./TipoPlanilha";
import TIPOS_PLANILHA from "../../data/TiposPlanilha";
import Random from "../../utils/strings/Random";
import ButtonTipoTreino from './ButtonTipoTreino';
import SEXOS from "../../data/Sexos";
import STRINGS from './../../data/language/language';
import HOME_TYPE from "../../data/HomeType";


const CLASS_SEXO_PLANILHA = " planilha-detalhe ";
const CLASS_REFERENCE = "tipo-planilha-";

class Planilha extends React.Component{
    constructor (props){
      super(props);

      this.changeTipoTreino = this.changeTipoTreino.bind(this);
      this.state = {
        id:props.id,
        ativo:0,
        dados:props.data,
        treinoAtivo:HOME_TYPE[0].value,
        tiposTreino:HOME_TYPE,
        strings:STRINGS[window.LANGUAGE],
      }
    }

    changeTipoTreino (e){
      let id = e.currentTarget.getAttribute("data-id");
      this.setState({treinoAtivo: id});
      e.preventDefault();
    }

    render(){
      const tiposTreino = this.state.tiposTreino;
      const treinoAtivo = this.state.treinoAtivo;
      const sexoAtivo = this.props.sexoAtivo;

      const listTiposTreino= tiposTreino.map((tipoTreino,i)=>{
          let ativo = tipoTreino.value === treinoAtivo;
          const data = this.state.dados[tipoTreino.identifier] ? this.state.dados[tipoTreino.identifier]  : [];

          return (
            <TipoPlanilha
              sexoAtivo={sexoAtivo}
              identifier={tipoTreino.identifier}
              data={data}
              id={Random(7)}
              key={i.toString()}
              ativo={ativo}>
            </TipoPlanilha>
          )
        }
      );//end map

      const buttonsTiposTreino= tiposTreino.map((tipoTreino,i)=>{
        let ativo = tipoTreino.value === treinoAtivo;
          return (
            <ButtonTipoTreino
              key={i.toString()}
              id={tipoTreino.value}
              onClick={this.changeTipoTreino}
              label={tipoTreino.label}
              ativo={ativo}>
            </ButtonTipoTreino>
          )
        }
      );//end map

      let _id = this.state.id;
      let _classes = CLASS_SEXO_PLANILHA+(this.props.ativo ? "ativo" : "");

      const { tipoDePlanilha } = this.state.strings;

      return(
        <div className={_classes} id={_id} data-id={this.props.identifier}>

          <div className="pure-u-15-24 box-tipos-planilha">
            <div className="box-input--title">{tipoDePlanilha}</div>
            {buttonsTiposTreino}
          </div>
          {listTiposTreino}
        </div>
      )
    }
}

export default Planilha;



// WEBPACK FOOTER //
// ./src/classes/treino-home/Planilha.js